'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var styled = require('styled-components');
var PropTypes = require('prop-types');
var index = require('../core/index.js');
var icon = require('./icon.js');
var text = require('./text.js');
var themeGet = require('../utils/themeGet.js');
var motion = require('../theme/motion.js');
var useClickAway = require('../hooks/useClickAway.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  position: fixed;\n  bottom: 42px;\n  ", ": 42px;\n  background-color: rgba(0, 0, 0, 0.6);\n  height: ", ";\n  width: ", ";\n  overflow: scroll;\n  box-shadow: ", "px 0 4px\n    rgba(0, 0, 0, 0.15);\n  transform: ", ";\n  transition: transform ", " ", ";\n  z-index: ", ";\n  border-radius: 8px;\n  padding: 16px;\n  color: ", ";\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var Content = styled__default['default'].div(_templateObject(), function (props) {
  return props.position || 'right';
}, function (props) {
  return props.height || "max-content";
}, function (props) {
  return props.width || "270px";
}, function (props) {
  return props.position === 'left' ? '2' : '-2';
}, function (props) {
  return props.open ? '' : "translateX(calc(".concat(props.position === 'left' ? '-' : '', "100% + 42px))");
}, motion.durationSlow, motion.easeBaseOut, function (props) {
  return props.zIndex || 9;
}, function (_ref) {
  var feedback = _ref.feedback;
  return feedback === 'danger' ? themeGet['default']('colors.red.03') : feedback === 'success' ? themeGet['default']('colors.green.02') : themeGet['default']('colors.grey.02');
}, index.styleEngine);

var Notification = function Notification(_ref2) {
  var propVisible = _ref2.visible,
      autoClose = _ref2.autoClose,
      autoCloseTimeInMillis = _ref2.autoCloseTimeInMillis,
      children = _ref2.children,
      onClose = _ref2.onClose,
      onOpen = _ref2.onOpen,
      content = _ref2.content,
      render = _ref2.render,
      feedback = _ref2.feedback,
      rest = _objectWithoutProperties(_ref2, ["visible", "autoClose", "autoCloseTimeInMillis", "children", "onClose", "onOpen", "content", "render", "feedback"]);

  var _useState = React.useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      visible = _useState2[0],
      setVisible = _useState2[1];

  var _useState3 = React.useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      open = _useState4[0],
      setOpen = _useState4[1];

  React.useEffect(function () {
    setVisible(propVisible);

    if (propVisible) {
      setOpen(true);
    }

    var autoCloseTimeout;
    if (autoClose) autoClose = setTimeout(function () {
      setOpen(false);
      setVisible(false);
    }, autoCloseTimeInMillis);
    return function () {
      clearTimeout(autoCloseTimeout);
    };
  }, [propVisible]);
  var ref = useClickAway['default'](function () {
    setVisible(false);
  });

  if (!propVisible && !open) {
    return null;
  }

  return /*#__PURE__*/React__default['default'].createElement(Content, _extends({
    onTransitionEnd: function onTransitionEnd() {
      if (visible) {
        onOpen && onOpen();
      } else {
        setOpen(false);
        onClose && onClose();
      }
    },
    open: visible,
    feedback: feedback,
    ref: ref
  }, rest), /*#__PURE__*/React__default['default'].createElement(icon['default'], {
    onClick: function onClick() {
      return setVisible(false);
    },
    icon: "pyt-tickmark-16",
    marginLeft: "2px",
    marginRight: "8px",
    borderRadius: "50%",
    padding: "8px",
    fontWeight: 600,
    background: feedback === 'success' ? 'rgba(229, 249, 243, 0.1)' : feedback === 'danger' ? 'rgba(229, 249, 243, 0.1)' : 'white'
  }), render ? render() : /*#__PURE__*/React__default['default'].createElement(text['default'], {
    variant: "bold"
  }, content), /*#__PURE__*/React__default['default'].createElement(icon['default'], {
    onClick: function onClick() {
      return setVisible(false);
    },
    icon: "pyt-close-16",
    marginLeft: "2px",
    color: "grey.03",
    cursor: "pointer",
    position: "absolute",
    right: "12px"
  }));
};
Notification.propTypes = {
  position: PropTypes__default['default'].oneOf(['left', 'right']),
  onOpen: PropTypes__default['default'].func,
  onClose: PropTypes__default['default'].func,
  width: PropTypes__default['default'].string,
  autoClose: PropTypes__default['default'].bool,
  autoCloseTimeInMillis: PropTypes__default['default'].number,
  closeOnClick: PropTypes__default['default'].bool,
  closeOnClickAway: PropTypes__default['default'].bool,
  visible: PropTypes__default['default'].bool,
  children: PropTypes__default['default'].node,
  zIndex: PropTypes__default['default'].number,
  className: PropTypes__default['default'].string
};
Notification.defaultProps = {
  autoCloseTimeInMillis: 2000
};

exports.default = Notification;
